import BrandBrick from "@/components/landing/BrandBrick";
import { Phone, Mail } from "lucide-react";

const links = [
  { href: "#services", label: "Services" },
  { href: "#comparison", label: "Fair Pricing" },
  { href: "#interactive", label: "Fix Diagnostic" },
  { href: "#bonus", label: "Client Bonus" },
  { href: "#deposit", label: "Deposit" },
  { href: "#about", label: "About" },
  { href: "#reviews", label: "Reviews" },
  { href: "#contact", label: "Request Quote" },
];

export default function Footer() {
  return (
    <footer className="bg-[#141A1E] text-[#8F9BA6] py-12 border-t border-[#232D34] text-xs" data-testid="footer">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col lg:flex-row lg:flex-wrap items-center justify-between gap-6 pb-8 border-b border-[#232D34]">
          <div className="flex flex-col items-center gap-1">
            <BrandBrick small />
            <span data-testid="footer-brand-description" className="font-bold text-white text-xs">South Louisiana Handyman Services</span>
          </div>
          <div className="flex flex-wrap items-center gap-4 text-[#A39B92]">
            <a href="tel:+12258927777" data-testid="footer-phone-link" className="flex items-center gap-1.5 hover:text-white transition-colors">
              <Phone className="w-3.5 h-3.5" /> (225) 892-7777
            </a>
            <a href="mailto:handyman.ionlyfix@gmail.com" data-testid="footer-email-link" className="flex items-center gap-1.5 hover:text-white transition-colors">
              <Mail className="w-3.5 h-3.5" /> handyman.ionlyfix@gmail.com
            </a>
          </div>
          <div className="flex flex-wrap gap-6 text-[#A39B92]">
            {links.map((l) => (
              <a key={l.href} href={l.href} data-testid={`footer-link-${l.href.slice(1)}`} className="hover:text-white transition-colors">
                {l.label}
              </a>
            ))}
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p>Licensed &bull; EPA Universal Certified &bull; Residential Specialist</p>
          <p className="text-[#64717C]">Honest, dependable repairs for your home and property.</p>
        </div>
      </div>
    </footer>
  );
}
